module.exports = __webpack_public_path__ + "img/017-basket.3831bc57.png";